function c(o, s) {
  o.pos = o.pos.map((p, r) => p + s.pos[r]), o.rot = o.rot.map((p, r) => p + s.rot[r]);
}
export {
  c as applyObjectTransform
};
//# sourceMappingURL=index2.js.map
